import React from 'react';
export type Mode = 'Date' | 'RelativeDate' | 'PeriodStartEnd';
export type Modes = {
    [field: string]: Mode;
};
export const initialModeContext = React.createContext<Modes>({});
